import { ErrorLink } from "@apollo/client/link/error";
import { CombinedGraphQLErrors, ServerError } from "@apollo/client/errors";
import { redirectToLogin } from "@/pages/Login/auth.config";

export function isAuthFailure(error: unknown): boolean {
  return ServerError.is(error) && error.statusCode === 401;
}

export const handleLinkError: ErrorLink.ErrorHandler = ({
  error,
  operation,
}) => {
  if (isAuthFailure(error)) {
    console.warn("Session expired, redirecting to login");
    // Fire-and-forget: the once-guard latches synchronously and the redirect
    // is a full-document navigation, so there is nothing to await for.
    void redirectToLogin();
    return;
  }

  if (CombinedGraphQLErrors.is(error)) {
    error.errors.forEach(({ message, locations, path }) => {
      console.warn(`Graphql error ${message} -- ${locations} -- ${path}`);
    });
  } else {
    console.error(
      "Network error: operationName:" + operation.operationName,
      operation,
      { error },
    );
  }
};

export const authErrorLink = new ErrorLink(handleLinkError);
